import React from "react";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const SavedAddressCard = ({
  addr,
  selectedId,
  showForm,
  onSelect,
  onEdit,
  onDelete,
}) => {
  const addressId = addr.address_id ?? addr.id;
  const isSelected = String(selectedId) === String(addressId) && !showForm;

  return (
    <div
      className={`relative rounded-2xl border-2 p-4 transition-all ${
        isSelected
          ? "border-primary-500 bg-primary-50 shadow-md shadow-primary-100"
          : "border-gray-200 bg-white hover:border-primary-300 hover:shadow-sm"
      }`}
    >
      {addr.is_default && (
        <span className="absolute right-4 top-4 rounded-md bg-primary-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-primary-600">
          Default
        </span>
      )}

      {/* Selectable top area */}
      <div className="flex cursor-pointer items-start gap-3" onClick={onSelect}>
        <span
          className={`mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
            isSelected ? "border-primary-500" : "border-gray-300"
          }`}
        >
          {isSelected && (
            <span className="h-2 w-2 rounded-full bg-primary-500" />
          )}
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 text-gray-400">
              <LocationOnOutlinedIcon style={{ fontSize: 13 }} />
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-gray-500">
              {addr.address_type || addr.type || "Home"}
            </span>
          </div>
          {addr.name && (
            <p className="mt-1 text-sm font-semibold text-gray-800">
              {addr.name}
            </p>
          )}
          {addr.email && <p className="text-xs text-gray-400">{addr.email}</p>}
          <p className="mt-0.5 text-sm text-gray-600">
            {addr.address || addr.street}
            {addr.locality ? `, ${addr.locality}` : ""}
          </p>
          <p className="text-xs text-gray-500">
            {[addr.city, addr.state, addr.pincode].filter(Boolean).join(", ")}
          </p>
        </div>
      </div>

      {/* Edit / Delete inline */}
      <div className="mt-3 flex items-center gap-2 border-t border-gray-100 pt-3">
        <button
          type="button"
          onClick={onEdit}
          className="flex items-center gap-1 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-semibold text-gray-500 transition hover:bg-gray-50 hover:text-primary-600"
        >
          <svg
            className="h-3 w-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
          Edit
        </button>
        <button
          type="button"
          onClick={onDelete}
          className="flex items-center gap-1 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-semibold text-gray-500 transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
        >
          <svg
            className="h-3 w-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          Delete
        </button>
      </div>
    </div>
  );
};

export default SavedAddressCard;
